import {
  ISetHideOfferInfo,
  ISetHideOfferState,
  IHideOfferComplainToggleAction,
  IHideOfferTopPopupToggleAction,
} from './types';

export function setHideOfferState(hideOfferInfo: ISetHideOfferInfo): ISetHideOfferState {
  return {
    type: 'ISetHideOfferState',
    ...hideOfferInfo,
  };
}

export function toggleComplainPopup(isComplainOpened: boolean): IHideOfferComplainToggleAction {
  return {
    isComplainOpened,
    type: 'IHideOfferComplainToggleAction',
  };
}

export function toggleTopPopup(isTopPopupOpened: boolean): IHideOfferTopPopupToggleAction {
  return {
    isTopPopupOpened,
    type: 'IHideOfferTopPopupToggleAction',
  };
}
